import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import baseHelper from '../../helpers/BaseHelper';

import * as ticketSeatTypes from '../../redux/futures/ticket_seat/types';
import ticketSeatActions from '../../redux/futures/ticket_seat/actions';

import LoadingScene from '../../components/LoadingScene';

import Input from '../../components/Input';
import produce from 'immer';
import LadiPagination from '../../components/LadiPagination';

import appConfig from '../../config/app';

export default function ListTicket(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const ticketSeat = useSelector((state) => state.ticketSeatReducer);

    const tabActive = {
        ALL: 'ALL',
        CHECKED_IN: 'CHECKED_IN',
        CHECK_IN: 'CHECK_IN',
    };

    const [tabCheckinActive, setTabCheckinActive] = useState('ALL');

    const [dataTicketSeats, setDataTicketSeats] = useState([]);

    const [valueInputSearch, setValueInputSearch] = useState('');

    const [limit, setLimit] = useState(20);
    // const [totalRecord, setTotalRecord] = useState(0);

    const [conditions, setConditions] = useState({
        page: 1,
        limit: appConfig.PAGINATION.LIMIT_OPTIONS[0].value,
    });

    // const [decodedResults, setDecodedResults] = useState([]);

    useEffect(() => {
        const search = props.location.search;
        let { event_id: eventID } = queryString.parse(search);
        let { ticket_seat_code: ticketSeatCode } = queryString.parse(search);

        if (ticketSeatCode) {
            history.push({
                pathname: '/checkin/info-handle',
                search: `ticket_seat_code=${ticketSeatCode}`,
            });
        }

        if (eventID) {
            let params = {
                paged: conditions.page,
                limit: conditions.limit,
                search: {
                    event_id: eventID,
                },
            };
            // params.search.event_id = eventID;
            dispatch(ticketSeatActions.list(params));
        }
    }, []);

    useEffect(() => {
        const search = props.location.search;
        let { event_id: eventID } = queryString.parse(search);
        let params = {
            paged: conditions.page,
            limit: conditions.limit,
            search: {
                event_id: eventID,
            },
        };

        dispatch(ticketSeatActions.list(params));
    }, [conditions]);

    const handleCheckinQrCode = async () => {
        history.push('/check-qrcode');
    };

    const handleChangeTab = (value) => {
        const search = props.location.search;
        let { event_id: eventID } = queryString.parse(search);
        let params = {
            paged: conditions.page,
            limit: conditions.limit,
            search: {
                event_id: eventID,
            },
        };
        setTabCheckinActive(value);
        switch (value) {
            case 'ALL':
                break;
            case 'CHECKED_IN':
                params.search.checked_in = 1;
                break;
            case 'CHECK_IN':
                params.search.checked_in = 0;
                break;
        }

        dispatch(ticketSeatActions.list(params));
    };

    const handleCheckinAgain = (code) => {
        const search = props.location.search;
        let { event_id: eventID } = queryString.parse(search);

        if (code && eventID) {
            let params = {
                code: code,
                product_id: eventID,
            };
            dispatch(ticketSeatActions.checkIn(params));
        }
    };

    useEffect(() => {
        const search = props.location.search;

        if (ticketSeat.action === ticketSeatTypes.LIST_TICKET_SEAT) {
            if (ticketSeat.status) {
                if (ticketSeat.ticketSeats) {
                    setDataTicketSeats(ticketSeat.ticketSeats);
                }
            }
        }
        if (ticketSeat.action === ticketSeatTypes.CHECK_IN_TICKET_SEAT) {
            if (ticketSeat.status) {
                window.LadiUI.toastCustom('success', '', ticketSeat.message);
                setDataTicketSeats(
                    produce(dataTicketSeats, (draft) => {
                        draft.map((_draft, index) => {
                            if (_draft.ticket_seat_id == ticketSeat.ticket_seat_id) {
                                _draft.checked_in = 1;
                            }
                        });
                    })
                );
            } else {
                window.LadiUI.showErrorMessage('Thông báo', ticketSeat.message, 'OK');
            }
        }

        if (ticketSeat.action === ticketSeatTypes.CHANGE_CHECK_IN) {
            if (ticketSeat.status) {
                window.LadiUI.toastCustom('success', '', ticketSeat.message);
                setDataTicketSeats(
                    produce(dataTicketSeats, (draft) => {
                        draft.map((_draft, index) => {
                            if (_draft.ticket_seat_id == ticketSeat.ticket_seat_id) {
                                _draft.checked_in = 0;
                            }
                        });
                    })
                );
            } else {
                window.LadiUI.showErrorMessage('Thông báo', ticketSeat.message, 'OK');
            }
        }
    }, [ticketSeat]);

    const handleCheckin = (item) => {
        const search = props.location.search;
        let { event_id: eventID } = queryString.parse(search);

        if (eventID && item.code) {
            let params = {
                code: item.code,
                product_id: eventID,
            };
            dispatch(ticketSeatActions.checkIn(params));
        }
    };

    const handleCancelCheckin = (item) => {
        let message = 'Bạn có muốn bỏ check in cho sự kiện này ?';
        let params = {};
        if (window.confirm(message) == true) {
            if (item.checked_in && item.ticket_seat_id) {
                if (item.checked_in == 0) {
                    params = {
                        checked_in: 1,
                        ticket_seat_id: item.ticket_seat_id,
                    };
                } else {
                    params = {
                        checked_in: 0,
                        ticket_seat_id: item.ticket_seat_id,
                    };
                }
                dispatch(ticketSeatActions.changeCheckIn(params));
            }
        }
    };

    const onChangeInputSearch = (e) => {
        let value = e.target.value;
        setValueInputSearch(value);
    };

    const onKeyDownInput = (event) => {
        const search = props.location.search;
        let { event_id: eventID } = queryString.parse(search);
        let params = {
            paged: conditions.page,
            limit: conditions.limit,
            search: {
                keyword: valueInputSearch,
                event_id: eventID,
            },
        };
        if (event.key === 'Enter') {
            dispatch(ticketSeatActions.list(params));
        }
    };

    const onChangeLimit = async (option) => {
        let conditionsTg = { ...conditions };
        conditionsTg.limit = option.value;
        await setConditions(conditionsTg);
    };

    const onPageChange = async (pageNumber) => {
        let conditionsTg = { ...conditions };
        conditionsTg.page = pageNumber;
        await setConditions(conditionsTg);
    };

    const { totalRecord } = ticketSeat;
    let fromItem = 0;
    let toItem = 0;

    if ((ticketSeat.ticketSeats || []).length > 0) {
        fromItem = (conditions.page - 1) * conditions.limit + 1;
        toItem = fromItem + ticketSeat.ticketSeats.length - 1;
    }

    const msgShowItem = `${t('PAGINATION.SHOW')} ${fromItem} ${t('PAGINATION.TO')} ${toItem} ${t(
        'PAGINATION.OF'
    )} ${totalRecord} khách tham dự.`;

    return (
        <>
            <div className='page-content page-checkin-content p-0'>
                <div className='block-header-checkin'>
                    <div className='content-header'>
                        <div className='qr-code mr-24' onClick={handleCheckinQrCode}>
                            <svg width='30' height='40' viewBox='0 0 30 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path
                                    d='M1 0.875C1 0.642936 1.09219 0.420376 1.25628 0.256282C1.42038 0.0921873 1.64294 0 1.875 0L7.125 0C7.35706 0 7.57962 0.0921873 7.74372 0.256282C7.90781 0.420376 8 0.642936 8 0.875C8 1.10706 7.90781 1.32962 7.74372 1.49372C7.57962 1.65781 7.35706 1.75 7.125 1.75H2.75V6.125C2.75 6.35706 2.65781 6.57962 2.49372 6.74372C2.32962 6.90781 2.10706 7 1.875 7C1.64294 7 1.42038 6.90781 1.25628 6.74372C1.09219 6.57962 1 6.35706 1 6.125V0.875ZM22 0.875C22 0.642936 22.0922 0.420376 22.2563 0.256282C22.4204 0.0921873 22.6429 0 22.875 0L28.125 0C28.3571 0 28.5796 0.0921873 28.7437 0.256282C28.9078 0.420376 29 0.642936 29 0.875V6.125C29 6.35706 28.9078 6.57962 28.7437 6.74372C28.5796 6.90781 28.3571 7 28.125 7C27.8929 7 27.6704 6.90781 27.5063 6.74372C27.3422 6.57962 27.25 6.35706 27.25 6.125V1.75H22.875C22.6429 1.75 22.4204 1.65781 22.2563 1.49372C22.0922 1.32962 22 1.10706 22 0.875V0.875ZM1.875 21C2.10706 21 2.32962 21.0922 2.49372 21.2563C2.65781 21.4204 2.75 21.6429 2.75 21.875V26.25H7.125C7.35706 26.25 7.57962 26.3422 7.74372 26.5063C7.90781 26.6704 8 26.8929 8 27.125C8 27.3571 7.90781 27.5796 7.74372 27.7437C7.57962 27.9078 7.35706 28 7.125 28H1.875C1.64294 28 1.42038 27.9078 1.25628 27.7437C1.09219 27.5796 1 27.3571 1 27.125V21.875C1 21.6429 1.09219 21.4204 1.25628 21.2563C1.42038 21.0922 1.64294 21 1.875 21V21ZM28.125 21C28.3571 21 28.5796 21.0922 28.7437 21.2563C28.9078 21.4204 29 21.6429 29 21.875V27.125C29 27.3571 28.9078 27.5796 28.7437 27.7437C28.5796 27.9078 28.3571 28 28.125 28H22.875C22.6429 28 22.4204 27.9078 22.2563 27.7437C22.0922 27.5796 22 27.3571 22 27.125C22 26.8929 22.0922 26.6704 22.2563 26.5063C22.4204 26.3422 22.6429 26.25 22.875 26.25H27.25V21.875C27.25 21.6429 27.3422 21.4204 27.5063 21.2563C27.6704 21.0922 27.8929 21 28.125 21ZM8 7H9.75V8.75H8V7Z'
                                    fill='black'
                                />
                                <path
                                    d='M13.25 3.5H4.5V12.25H13.25V3.5ZM6.25 5.25H11.5V10.5H6.25V5.25ZM9.75 19.25H8V21H9.75V19.25Z'
                                    fill='black'
                                />
                                <path
                                    d='M13.25 15.75H4.5V24.5H13.25V15.75ZM6.25 17.5H11.5V22.75H6.25V17.5ZM20.25 7H22V8.75H20.25V7Z'
                                    fill='black'
                                />
                                <path
                                    d='M16.75 3.5H25.5V12.25H16.75V3.5ZM18.5 5.25V10.5H23.75V5.25H18.5ZM15 14V17.5H16.75V19.25H15V21H18.5V17.5H20.25V21H22V19.25H25.5V17.5H20.25V14H15ZM18.5 17.5H16.75V15.75H18.5V17.5ZM25.5 21H23.75V22.75H20.25V24.5H25.5V21ZM18.5 24.5V22.75H15V24.5H18.5Z'
                                    fill='black'
                                />
                                <path d='M22 15.75H25.5V14H22V15.75Z' fill='black' />
                                <path
                                    d='M3.57812 37.3477L5.02344 38.4922L4.51562 38.9609L3.09375 37.832L3.57812 37.3477ZM5.00391 34.9766V35.3359C5.00391 35.763 4.95052 36.1458 4.84375 36.4844C4.73698 36.8229 4.58333 37.1107 4.38281 37.3477C4.18229 37.5846 3.94141 37.7656 3.66016 37.8906C3.38151 38.0156 3.06901 38.0781 2.72266 38.0781C2.38672 38.0781 2.07812 38.0156 1.79688 37.8906C1.51823 37.7656 1.27604 37.5846 1.07031 37.3477C0.867188 37.1107 0.709635 36.8229 0.597656 36.4844C0.485677 36.1458 0.429688 35.763 0.429688 35.3359V34.9766C0.429688 34.5495 0.484375 34.168 0.59375 33.832C0.705729 33.4935 0.863281 33.2057 1.06641 32.9688C1.26953 32.7292 1.51042 32.5469 1.78906 32.4219C2.07031 32.2969 2.37891 32.2344 2.71484 32.2344C3.0612 32.2344 3.375 32.2969 3.65625 32.4219C3.9375 32.5469 4.17839 32.7292 4.37891 32.9688C4.57943 33.2057 4.73307 33.4935 4.83984 33.832C4.94922 34.168 5.00391 34.5495 5.00391 34.9766ZM4.25781 35.3359V34.9688C4.25781 34.6302 4.22266 34.3307 4.15234 34.0703C4.08464 33.8099 3.98438 33.5911 3.85156 33.4141C3.71875 33.237 3.55729 33.1029 3.36719 33.0117C3.17708 32.9206 2.95964 32.875 2.71484 32.875C2.48307 32.875 2.27214 32.9206 2.08203 33.0117C1.89453 33.1029 1.73307 33.237 1.59766 33.4141C1.46224 33.5911 1.35807 33.8099 1.28516 34.0703C1.21224 34.3307 1.17578 34.6302 1.17578 34.9688V35.3359C1.17578 35.6771 1.21224 35.9792 1.28516 36.2422C1.35807 36.5026 1.46224 36.7227 1.59766 36.9023C1.73568 37.0794 1.89974 37.2135 2.08984 37.3047C2.27995 37.3958 2.49089 37.4414 2.72266 37.4414C2.96745 37.4414 3.1849 37.3958 3.375 37.3047C3.5651 37.2135 3.72526 37.0794 3.85547 36.9023C3.98828 36.7227 4.08854 36.5026 4.15625 36.2422C4.22396 35.9792 4.25781 35.6771 4.25781 35.3359ZM8.64453 37.0234V33.7734H9.37109V38H8.67969L8.64453 37.0234ZM8.78125 36.1328L9.08203 36.125C9.08203 36.4062 9.05208 36.6667 8.99219 36.9062C8.9349 37.1432 8.84115 37.349 8.71094 37.5234C8.58073 37.6979 8.41016 37.8346 8.19922 37.9336C7.98828 38.0299 7.73177 38.0781 7.42969 38.0781C7.22396 38.0781 7.03516 38.0482 6.86328 37.9883C6.69401 37.9284 6.54818 37.8359 6.42578 37.7109C6.30339 37.5859 6.20833 37.4232 6.14062 37.2227C6.07552 37.0221 6.04297 36.7812 6.04297 36.5V33.7734H6.76562V36.5078C6.76562 36.6979 6.78646 36.8555 6.82812 36.9805C6.8724 37.1029 6.93099 37.2005 7.00391 37.2734C7.07943 37.3438 7.16276 37.3932 7.25391 37.4219C7.34766 37.4505 7.44401 37.4648 7.54297 37.4648C7.85026 37.4648 8.09375 37.4062 8.27344 37.2891C8.45312 37.1693 8.58203 37.0091 8.66016 36.8086C8.74089 36.6055 8.78125 36.3802 8.78125 36.1328ZM12.2266 38.0781C11.9323 38.0781 11.6654 38.0286 11.4258 37.9297C11.1888 37.8281 10.9844 37.6862 10.8125 37.5039C10.6432 37.3216 10.513 37.1055 10.4219 36.8555C10.3307 36.6055 10.2852 36.332 10.2852 36.0352V35.8711C10.2852 35.5273 10.3359 35.2214 10.4375 34.9531C10.5391 34.6823 10.6771 34.4531 10.8516 34.2656C11.026 34.0781 11.224 33.9362 11.4453 33.8398C11.6667 33.7435 11.8958 33.6953 12.1328 33.6953C12.4349 33.6953 12.6953 33.7474 12.9141 33.8516C13.1354 33.9557 13.3164 34.1016 13.457 34.2891C13.5977 34.474 13.7018 34.6927 13.7695 34.9453C13.8372 35.1953 13.8711 35.4688 13.8711 35.7656V36.0898H10.7148V35.5H13.1484V35.4453C13.138 35.2578 13.099 35.0755 13.0312 34.8984C12.9661 34.7214 12.862 34.5755 12.7188 34.4609C12.5755 34.3464 12.3802 34.2891 12.1328 34.2891C11.9688 34.2891 11.8177 34.3242 11.6797 34.3945C11.5417 34.4622 11.4232 34.5638 11.3242 34.6992C11.2253 34.8346 11.1484 35 11.0938 35.1953C11.0391 35.3906 11.0117 35.6159 11.0117 35.8711V36.0352C11.0117 36.2357 11.0391 36.4245 11.0938 36.6016C11.151 36.776 11.2331 36.9297 11.3398 37.0625C11.4492 37.1953 11.5807 37.2995 11.7344 37.375C11.8906 37.4505 12.0677 37.4883 12.2656 37.4883C12.5208 37.4883 12.737 37.4362 12.9141 37.332C13.0911 37.2279 13.2461 37.0885 13.3789 36.9141L13.8164 37.2617C13.7253 37.3997 13.6094 37.5312 13.4688 37.6562C13.3281 37.7812 13.1549 37.8828 12.9492 37.9609C12.7461 38.0391 12.5052 38.0781 12.2266 38.0781ZM11.7305 33.1484L12.4883 32H13.3594L12.3125 33.1484H11.7305ZM16.4844 33.7734V34.3281H14.1992V33.7734H16.4844ZM14.9727 32.7461H15.6953V36.9531C15.6953 37.0964 15.7174 37.2044 15.7617 37.2773C15.806 37.3503 15.8633 37.3984 15.9336 37.4219C16.0039 37.4453 16.0794 37.457 16.1602 37.457C16.2201 37.457 16.2826 37.4518 16.3477 37.4414C16.4154 37.4284 16.4661 37.418 16.5 37.4102L16.5039 38C16.4466 38.0182 16.3711 38.0352 16.2773 38.0508C16.1862 38.069 16.0755 38.0781 15.9453 38.0781C15.7682 38.0781 15.6055 38.043 15.457 37.9727C15.3086 37.9023 15.1901 37.7852 15.1016 37.6211C15.0156 37.4544 14.9727 37.2305 14.9727 36.9492V32.7461ZM22.3438 37.3477L23.7891 38.4922L23.2812 38.9609L21.8594 37.832L22.3438 37.3477ZM23.7695 34.9766V35.3359C23.7695 35.763 23.7161 36.1458 23.6094 36.4844C23.5026 36.8229 23.349 37.1107 23.1484 37.3477C22.9479 37.5846 22.707 37.7656 22.4258 37.8906C22.1471 38.0156 21.8346 38.0781 21.4883 38.0781C21.1523 38.0781 20.8438 38.0156 20.5625 37.8906C20.2839 37.7656 20.0417 37.5846 19.8359 37.3477C19.6328 37.1107 19.4753 36.8229 19.3633 36.4844C19.2513 36.1458 19.1953 35.763 19.1953 35.3359V34.9766C19.1953 34.5495 19.25 34.168 19.3594 33.832C19.4714 33.4935 19.6289 33.2057 19.832 32.9688C20.0352 32.7292 20.276 32.5469 20.5547 32.4219C20.8359 32.2969 21.1445 32.2344 21.4805 32.2344C21.8268 32.2344 22.1406 32.2969 22.4219 32.4219C22.7031 32.5469 22.944 32.7292 23.1445 32.9688C23.3451 33.2057 23.4987 33.4935 23.6055 33.832C23.7148 34.168 23.7695 34.5495 23.7695 34.9766ZM23.0234 35.3359V34.9688C23.0234 34.6302 22.9883 34.3307 22.918 34.0703C22.8503 33.8099 22.75 33.5911 22.6172 33.4141C22.4844 33.237 22.3229 33.1029 22.1328 33.0117C21.9427 32.9206 21.7253 32.875 21.4805 32.875C21.2487 32.875 21.0378 32.9206 20.8477 33.0117C20.6602 33.1029 20.4987 33.237 20.3633 33.4141C20.2279 33.5911 20.1237 33.8099 20.0508 34.0703C19.9779 34.3307 19.9414 34.6302 19.9414 34.9688V35.3359C19.9414 35.6771 19.9779 35.9792 20.0508 36.2422C20.1237 36.5026 20.2279 36.7227 20.3633 36.9023C20.5013 37.0794 20.6654 37.2135 20.8555 37.3047C21.0456 37.3958 21.2565 37.4414 21.4883 37.4414C21.7331 37.4414 21.9505 37.3958 22.1406 37.3047C22.3307 37.2135 22.4909 37.0794 22.6211 36.9023C22.7539 36.7227 22.8542 36.5026 22.9219 36.2422C22.9896 35.9792 23.0234 35.6771 23.0234 35.3359ZM24.9336 32.3125H26.8164C27.2435 32.3125 27.6042 32.3776 27.8984 32.5078C28.1953 32.638 28.4206 32.8307 28.5742 33.0859C28.7305 33.3385 28.8086 33.6497 28.8086 34.0195C28.8086 34.2799 28.7552 34.5182 28.6484 34.7344C28.5443 34.9479 28.3932 35.1302 28.1953 35.2812C28 35.4297 27.7656 35.5404 27.4922 35.6133L27.2812 35.6953H25.5117L25.5039 35.082H26.8398C27.1107 35.082 27.3359 35.0352 27.5156 34.9414C27.6953 34.8451 27.8307 34.7161 27.9219 34.5547C28.013 34.3932 28.0586 34.2148 28.0586 34.0195C28.0586 33.8008 28.0156 33.6094 27.9297 33.4453C27.8438 33.2812 27.7083 33.1549 27.5234 33.0664C27.3411 32.9753 27.1055 32.9297 26.8164 32.9297H25.6875V38H24.9336V32.3125ZM28.2578 38L26.875 35.4219L27.6602 35.418L29.0625 37.9531V38H28.2578Z'
                                    fill='black'
                                />
                            </svg>
                        </div>
                        <div className='ladiui form-group mb-0 mt-0'>
                            <Input
                                className={`ladiui form-control`}
                                name='name'
                                validationName={t('PRODUCTS.NAME')}
                                onChange={(e) => onChangeInputSearch(e)}
                                placeholder='Tìm kiếm tên, email hoặc số điện thoại'
                                value={valueInputSearch}
                                onKeyDown={onKeyDownInput}
                                validations={{ isRequired: true }}
                            />
                        </div>
                    </div>
                </div>
                <div className='block-guest-list'>
                    <div className='content'>
                        <h3>{ticketSeat.productName ? ticketSeat.productName : ''}</h3>
                        <div className='list-guest'>
                            <ul className='ladiui nav nav-tabs mb-24'>
                                <li className={`ladiui nav-item`} onClick={() => handleChangeTab(tabActive.ALL)}>
                                    <span className={`ladiui tab-link ${tabCheckinActive == tabActive.ALL ? 'active' : ''}`}>Tất cả</span>
                                </li>
                                <li className={`ladiui nav-item`} onClick={() => handleChangeTab(tabActive.CHECKED_IN)}>
                                    <span className={`ladiui tab-link ${tabCheckinActive == tabActive.CHECKED_IN ? 'active' : ''}`}>
                                        Đã checkin
                                    </span>
                                </li>
                                <li className={`ladiui nav-item`} onClick={() => handleChangeTab(tabActive.CHECK_IN)}>
                                    <span className={`ladiui tab-link ${tabCheckinActive == tabActive.CHECK_IN ? 'active' : ''}`}>
                                        Chưa checkin
                                    </span>
                                </li>
                            </ul>
                            <span className='title'>
                                Danh sách khách tham gia: ({ticketSeat.totalCheckin ? ticketSeat.totalCheckin : 0} /{' '}
                                {ticketSeat.totalRecord ? ticketSeat.totalRecord : 0})
                            </span>
                            <ul className='list'>
                                {dataTicketSeats &&
                                    dataTicketSeats.length > 0 &&
                                    dataTicketSeats.map((item, index) => {
                                        return (
                                            <li key={index} className='list-guest-item'>
                                                <div className='block-icon-check'>
                                                    <i
                                                        className={`ladi-icon icon-circle-check ${
                                                            item.checked_in == 0 ? 'check-in' : 'checked-in'
                                                        }`}
                                                    ></i>
                                                </div>
                                                <div className='info'>
                                                    <div>
                                                        <span className='info-item'>
                                                            <label>
                                                                Họ tên:{' '}
                                                                <strong>
                                                                    {(item.first_name ? item.first_name : '') +
                                                                        (item.last_name ? item.last_name : '')}
                                                                </strong>{' '}
                                                                <span className='phone'>{item.phone ? `(${item.phone})` : ''}</span>
                                                            </label>
                                                        </span>
                                                        <span className='info-item'>
                                                            <label>
                                                                Email: <strong>{item.email}</strong>
                                                            </label>
                                                        </span>
                                                        <span className='info-item'>
                                                            <label>
                                                                Mã vé:{' '}
                                                                <strong>
                                                                    <a href={`/checkin/info-handle?ticket_seat_code=${item.code}`}>
                                                                        {item.code}
                                                                    </a>
                                                                </strong>
                                                            </label>
                                                        </span>
                                                        <span className='info-item'>
                                                            <label>
                                                                Loại vé: <strong>{item.option_name}</strong>
                                                            </label>
                                                        </span>
                                                        <span className='info-item'>
                                                            <label>
                                                                Ngày tạo: <strong>{baseHelper.formatDateToStr(item.created_at)}</strong>
                                                            </label>
                                                        </span>
                                                    </div>
                                                    <div className='block-icon-check'>
                                                        <i
                                                            className={`ladi-icon icon-circle-check ${
                                                                item.checked_in == 0 ? 'check-in' : 'checked-in'
                                                            }`}
                                                        ></i>
                                                    </div>
                                                    <div className='block-group-btn-checkin'>
                                                        {item.checked_in && item.checked_in != 0 ? (
                                                            <div className='group-btn-checkin flex'>
                                                                <button
                                                                    type='button'
                                                                    className='ladiui btn btn-outline-danger btn-sm mr-24'
                                                                    onClick={() => handleCancelCheckin(item)}
                                                                >
                                                                    Hủy check in
                                                                </button>
                                                                <button
                                                                    type='button'
                                                                    className='ladiui btn btn-primary btn-sm'
                                                                    onClick={() => handleCheckinAgain(item.code)}
                                                                >
                                                                    Check in lại
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className='btn-checkin'>
                                                                <button
                                                                    type='button'
                                                                    className='ladiui btn btn-primary btn-sm'
                                                                    onClick={() => handleCheckin(item)}
                                                                >
                                                                    Checkin
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='block-group-btn-checkin'>
                                                    {item.checked_in && item.checked_in != 0 ? (
                                                        <div className='group-btn-checkin flex'>
                                                            <button
                                                                type='button'
                                                                className='ladiui btn btn-outline-danger btn-sm mr-24'
                                                                onClick={() => handleCancelCheckin(item)}
                                                            >
                                                                Hủy check in
                                                            </button>
                                                            <button
                                                                type='button'
                                                                className='ladiui btn btn-primary btn-sm'
                                                                onClick={() => handleCheckinAgain(item.code)}
                                                            >
                                                                Check in lại
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div className='btn-checkin'>
                                                            <button
                                                                type='button'
                                                                className='ladiui btn btn-primary btn-sm'
                                                                onClick={() => handleCheckin(item)}
                                                            >
                                                                Checkin
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    })}
                            </ul>
                            {totalRecord > 0 && (
                                <LadiPagination
                                    conditionsProp={conditions}
                                    listName={t('PAGINATION.ITEMS')}
                                    innerClassName='pagination-checkin'
                                    message={msgShowItem}
                                    items={dataTicketSeats}
                                    total={totalRecord}
                                    limitAction={onChangeLimit}
                                    className=''
                                    pageAction={onPageChange}
                                />
                            )}
                        </div>
                        <div className='powered-by'>
                            <span>
                                Powered by{' '}
                                <img
                                    src='https://w.ladicdn.com/ladiui/icons/ldicon-colored-brand-ladisales.svg'
                                    className='ml-8 mr-8'
                                ></img>{' '}
                                <strong>Ladisales</strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
